import script from './script'
const errorScript = () => {
    return { script }
}
export default errorScript